import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api.js';
import { useEntityScope } from './useEntityScope.js';

const QUERY_KEY = ['cash-flow-layout'];

/**
 * Layout (sous-totaux personnalisés) du tableau cash-flow.
 * Désactivé en vue groupe : le layout est par entité, pas pertinent en agrégé.
 * Le tableau retombe sur le layout par défaut (toutes les catégories à plat).
 */
export function useCashFlowLayout() {
  const { isGroup } = useEntityScope();
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: () => api.get('/cash-flow/layout'),
    staleTime: 60_000,
    select: (data) => data?.rows ?? [],
    enabled: !isGroup,
  });
}

export function useSaveCashFlowLayout() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (rows) => api.put('/cash-flow/layout', { rows }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEY });
    },
  });
}
